import {
    createRouter,
    createWebHistory,
    NavigationGuardNext,
    RouteLocationNormalized,
} from "vue-router"

import PageNotFound from "@pages/PageNotFound.vue"
// import { useAuthStore } from "@stores/auth.store"
import LandingPage from "@pages/landing/LandingPage.vue"
import { nextTick } from "vue"
import MentionLegalesPage from "@pages/landing/MentionLegalesPage.vue"
import ConfidentialPolicyPage from "@pages/landing/ConfidentialPolicyPage.vue"
import FormPage from "@pages/form/FormPage.vue"
import UnsubscribePage from "@pages/UnsubscribePage.vue"

const routes = [
    {
        path: "/",
        name: "LandingPage",
        component: LandingPage,
    },
    {
        path: "/mentions-legales",
        name: "MentionsLegales",
        component: MentionLegalesPage,
    },
    {
        path: "/politique-de-confidentialite",
        name: "ConfidentialPolicy",
        component: ConfidentialPolicyPage,
    },
    {
        path: "/formulaire",
        name: "Form",
        component: FormPage,
        meta: { layout: "form", confirm: true },
    },
    {
        path: "/unsubscribe",
        name: "Unsubscribe",
        component: UnsubscribePage,
        meta: { layout: "form", confirm: true },
    },
    {
        path: "/:pathMatch(.*)*",
        name: "PageNotFound",
        component: PageNotFound,
        meta: { layout: "error" },
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to) {
        if (to.hash) {
            return new Promise((resolve) => {
                nextTick(() => {
                    const el = document.querySelector(to.hash)
                    if (el) {
                        el.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                        })
                    }
                    resolve()
                })
            })
        }
        return new Promise((resolve) => {
            nextTick(() => {
                const el = document.querySelector("#app")
                if (el) {
                    el.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    })
                }
                resolve()
            })
        })
    },
})

// router.beforeEach((to, _, next) => {
//     // ✅ works because the pinia instance is now active
//     const authStore = useAuthStore()

//     // en mode développement, on autorise l'accès à toutes les routes
//     if (import.meta.env.DEV) {
//         next()
//         return
//     }

//     if (to.matched.some((record) => record.meta.requiresAuth)) {
//         if (authStore.isLogged) {
//             next()
//         } else {
//             // on enregistre la route précédente pour rediriger l'utilisateur après la connexion
//             authStore.previousRoute = to.fullPath
//             next({ name: "LoginPage" })
//         }
//     } else {
//         next()
//     }
// })

// Guard global
router.beforeEach(
    (_, from: RouteLocationNormalized, next: NavigationGuardNext) => {
        // if (from.meta.confirm) {
        //     const confirmed = window.confirm(
        //         "Vous allez quitter une page avec des modifications non sauvegardées. Continuer ?"
        //     )
        //     if (!confirmed) {
        //         return next(false) // bloque la navigation
        //     }
        // }
        next() // sinon continue normalement
    }
)

export default router
